import useSeoData from '~/hooks/useSeoData';
import { SeoProps } from '~/server-props/contracts';
import ContentMods from '../Content/Content';
import ContentReviews from '../ContentReviews';
import InternalLinks from '../InternalLinkMod';

type OwnProps = {
  initialSeoProps?: SeoProps;
};

const ContentResultsResearch = ({ initialSeoProps }: OwnProps) => {
  const { seoContent, seoLinks, seoReviews } = useSeoData(initialSeoProps);

  return (
    <>
      <ContentMods mods={seoContent} />
      <ContentReviews contentReviews={seoReviews} />
      <InternalLinks links={seoLinks?.internalLinks} />
    </>
  );
};

export default ContentResultsResearch;
